import React, { useEffect } from 'react';
import { useNotification } from 'src/hooks/useNotification';
import { useNavigate, useParams } from 'react-router-dom';
import { useDeleteProjectMutation, useGetProjectByIdQuery } from 'src/services';
import { PATH_HOME } from 'src/constants/spa-routes';
import { Button } from 'src/components/ui/button';

export const ProjectDeleteContent = ({ close = () => {}, redirect = true, project }) => {
  const notification = useNotification();
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: currentProject } = useGetProjectByIdQuery({ id: id }, { skip: !id });

  const projectData = currentProject || project;

  const [deleteProject, { isLoading, isSuccess: isSuccessDelete }] = useDeleteProjectMutation();

  const deleteHandler = () => {
    deleteProject({
      projectId: projectData?.id || id,
      name: projectData.name,
      ai_reply_generation: projectData.ai_reply_generation,
      ai_text_lense: projectData.ai_text_lense,
    }).then(() => notification.success(`Project ${projectData.name} was deleted!`));
  };

  useEffect(() => {
    if (isSuccessDelete && !isLoading) {
      close();
    }
  }, [isSuccessDelete, isLoading]);

  useEffect(() => {
    if (isSuccessDelete) {
      if (redirect) {
        navigate(`${PATH_HOME.ROOT}`);
      }
    }
  }, [isSuccessDelete]);

  return (
    <>
      <div className="content">
        <div className="sub-title flex items-center gap-3.5">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
              stroke="#FF5151"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 14H10.01V14.01H10V14Z"
              stroke="#FF5151"
              strokeWidth="2.25"
              strokeLinejoin="round"
            />
            <path
              d="M10 10V6"
              stroke="#FF5151"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <h4 className="text-delete font-medium text-base font-jamjuree">
            Are you sure you want to delete ‘{projectData?.name}’ project irretrievably?
          </h4>
        </div>
      </div>
      <div className="footer flex justify-center mt-5">
        <div className="help-container"></div>
        <div className="action-buttons flex gap-2.5">
          <Button variant="outline" className="transparent black min-w-28" onClick={() => close()}>
            Cancel
          </Button>
          <Button disabled={isLoading} className="min-w-28" onClick={deleteHandler}>
            {isLoading ? 'Loading...' : 'Delete'}
          </Button>
        </div>
      </div>
    </>
  );
};
